 import React, { useRef, useState } from 'react'
 import Header from './header'
 import checkValidData from '../utils/validate'
 import { createUserWithEmailAndPassword,signInWithEmailAndPassword  } from "firebase/auth";
 import {auth} from '../utils/firebase'
import{useNavigate} from 'react-router-dom';
import { updateProfile } from "firebase/auth";
import { useDispatch } from 'react-redux';
import { addUser} from '../utils/userSlice'; 
import { BG_URL } from '../utils/constant';

 const Login = () => {
    const [isSignIn,setToisSignIn]=useState(true);
    const [errorMessage,seterrorMessage]=useState(null)
    const navigate=useNavigate(); 
    const dispatch=useDispatch();
    const [Name,setName]=useState(null)
   const [showPassword,setShowPassword]=useState(false)
    
    const ToggleSignIinForm=()=>{
        setToisSignIn(!isSignIn)
    }

  
const email=useRef(null);
const password=useRef(null);
const name=useRef(null);

const togglePasswordVisibility = () => {
  setShowPassword((prev) => !prev)
}


    const handleButtonClick=()=>{
        //Validate Form data
         
       const message=checkValidData(email.current.value,password.current.value)
         setName(message)
         seterrorMessage(message)
   
if(message) return  
 
if(!isSignIn){
    createUserWithEmailAndPassword(auth,email.current.value,password.current.value)
  .then((userCredential) => {
  const user = userCredential.user;
  
updateProfile(user, {
  displayName: name.current.value, photoURL: "https://i.pinimg.com/736x/f5/68/04/f56804886125925b781864924c8c8ddc.jpg"
}).then(() => {
   const {uid, email, displayName,photoURL} = auth.currentUser;
      dispatch(addUser({uid:uid, email: email, displayName: displayName, photoURL: photoURL}))
    
  navigate('/browse')
}).catch((error) => {
seterrorMessage(error.message)
});
   
     navigate('/browse')
  })
  .catch((error) => {
    const errorCode = error.code;
    const errorMessage = error.message;
   seterrorMessage(errorCode+errorMessage)
   
setName(errorCode+errorMessage)
    
  });


}else{
    signInWithEmailAndPassword(auth, email.current.value,password.current.value)
  .then((userCredential) => {
    const user = userCredential.user;
     
      navigate('/browse')
  })
  .catch((error) => {
    const errorCode = error.code;
    const errorMessage = error.message;
       seterrorMessage(errorCode+"-"+errorMessage)
     
  });


}
}
   return (
     <div className='relative min-h-screen w-full'>
        <Header/>
        <div className='absolute inset-0 -z-10'>
          <img className='h-full w-full object-cover' src={BG_URL} alt="bg" />
          <div className='absolute inset-0 bg-black/30' />
        </div>
    <form onSubmit={(e)=>e.preventDefault()} className='w-full md:w-3/12 absolute p-12 bg-black bg-opacity-80 my-36 mx-auto right-0 left-0 text-white  ' action="">
    <h1 className='font-bold text-3xl text-white py-3'>{isSignIn? "Sign In":"Sign Up"}</h1>
        { !isSignIn &&    <input ref={name} type="text" placeholder='Name' className='bg-zinc-900/70 border border-white-600 p-4 my-2 w-full rounded-md  '/>}
        
     
        <input ref={email} type="text" placeholder='Email' className='bg-zinc-900/70 border border-white-600 p-4 my-2 w-full rounded-md '/>
        <div className='relative'>
          <input
            ref={password}
            type={showPassword ? 'text' : 'password'}
            placeholder='Password'
            className='bg-zinc-900/70 border border-white-600 p-4 my-2 w-full rounded-md pr-20'
          />
          <button
            type='button'
            onClick={togglePasswordVisibility}
            className='absolute inset-y-0 right-3 my-2 text-sm text-zinc-800 hover:text-zinc-600'
          >
            {showPassword ? 'Hide' : 'Show'}
          </button>
        </div>
     <p className='text-red-500 font-bold text-sm'>{errorMessage}</p>
        <button className='bg-red-500 hover:bg-red-600 w-full p-4 m-4 mx-0 rounded-md' onClick={handleButtonClick}>{isSignIn? "Sign In":"Sign Up"}</button>
      
        <p className='p-3 m-0 ' onClick={ToggleSignIinForm}>{isSignIn?" New to Netflix, Sign up now": "Already registred, Sign Up now !"}</p>
    </form>
    </div>
   )
 }
 
 export default Login